(() => {
  if (window.riamatoWishlistReady) return;
  const source = document.getElementById('rm-wishlist-config');
  const dialog = document.getElementById('rm-wishlist-dialog');
  if (!source || !dialog) return;
  const config = JSON.parse(source.textContent);
  const labels = config.labels;
  const key = 'riamato.wishlist.v1';
  const list = document.getElementById('rm-wishlist-items');
  const empty = document.getElementById('rm-wishlist-empty');
  const status = document.getElementById('rm-wishlist-status');
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  let entries = [];
  let revision = 0;
  let opener;
  let previousOverflow;
  const productUrl = handle => root + 'products/' + encodeURIComponent(handle);
  const imageUrl = value => {
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' || url.origin === location.origin ? url.href : '';
    } catch { return ''; }
  };
  const normalise = value => {
    if (!Array.isArray(value)) return [];
    const seen = new Set();
    return value.filter(item => item && /^\d+$/.test(String(item.id)) && typeof item.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(item.handle) && !seen.has(String(item.id)) && seen.add(String(item.id))).slice(0, 200).map(item => ({
      id: String(item.id), handle: item.handle, title: String(item.title || item.handle).slice(0, 1000),
      image: typeof item.image === 'string' && item.image ? imageUrl(item.image) : '',
      price: Number.isFinite(Number(item.price)) ? Number(item.price) : 0,
      currency: typeof item.currency === 'string' ? item.currency : config.currency
    }));
  };
  const read = () => {
    try { return normalise(JSON.parse(localStorage.getItem(key) || '[]')); }
    catch { return []; }
  };
  const announce = text => {
    const target = dialog.open ? document.getElementById('rm-wishlist-dialog-status') : status;
    target.textContent = ''; requestAnimationFrame(() => { target.textContent = text; });
  };
  const save = next => {
    try { localStorage.setItem(key, JSON.stringify(next)); entries = next; return true; }
    catch { announce(labels.storage_error); return false; }
  };
  const price = item => {
    try { return new Intl.NumberFormat(config.locale, { style: 'currency', currency: item.currency }).format(item.price / 100); }
    catch { return ''; }
  };
  const sync = () => {
    const ids = new Set(entries.map(item => item.id));
    document.querySelectorAll('[data-rm-wishlist-toggle]').forEach(button => {
      const selected = ids.has(button.dataset.id);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', (selected ? labels.remove : labels.add) + ': ' + button.dataset.title);
      const label = button.querySelector('[data-rm-wishlist-label]');
      if (label) label.textContent = selected ? labels.remove : labels.add;
    });
    document.querySelectorAll('[data-rm-wishlist-open]').forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-label', labels.open + ' (' + entries.length + ')');
      button.setAttribute('aria-expanded', String(dialog.open));
    });
    document.querySelectorAll('[data-rm-wishlist-count]').forEach(counter => {
      counter.textContent = String(entries.length);
      counter.hidden = !entries.length;
    });
  };
  const render = () => {
    const token = ++revision;
    empty.hidden = entries.length > 0;
    list.replaceChildren();
    const rows = entries.map(item => {
      const row = document.createElement('li');
      row.className = 'rm-wishlist-item';
      const media = document.createElement('a');
      media.href = productUrl(item.handle);
      media.setAttribute('aria-label', item.title);
      const image = document.createElement('img');
      image.className = 'rm-wishlist-image'; image.alt = ''; image.width = 80; image.height = 100; image.loading = 'lazy';
      if (item.image) image.src = item.image;
      else image.hidden = true;
      media.append(image);
      const info = document.createElement('div'); info.className = 'rm-wishlist-info';
      const link = document.createElement('a'); link.href = productUrl(item.handle); link.textContent = item.title;
      const amount = document.createElement('p'); amount.className = 'rm-wishlist-price'; amount.textContent = price(item);
      const availability = document.createElement('p'); availability.className = 'rm-wishlist-availability';
      info.append(link, amount, availability);
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'rm-wishlist-remove'; remove.dataset.rmWishlistRemove = item.id; remove.textContent = '×'; remove.setAttribute('aria-label', labels.remove + ': ' + item.title);
      row.append(media, info, remove); list.append(row);
      return { item, image, link, amount, availability };
    });
    if (!dialog.open) return;
    let index = 0;
    const refresh = async () => {
      while (index < rows.length && token === revision && dialog.open) {
        const current = rows[index++];
        try {
          const response = await fetch(productUrl(current.item.handle) + '.js', { credentials: 'same-origin', signal: AbortSignal.timeout(8000) });
          if (token !== revision) return;
          if (response.status === 404) { current.availability.textContent = labels.unavailable; continue; }
          if (!response.ok) throw new Error('Product lookup failed');
          const product = await response.json();
          if (token !== revision || String(product.id) !== current.item.id) continue;
          current.link.textContent = product.title;
          current.amount.textContent = price({ price: product.price, currency: config.currency });
          current.availability.textContent = product.available ? '' : labels.sold_out;
          const freshImage = product.featured_image ? imageUrl(product.featured_image) : '';
          if (freshImage) { current.image.src = freshImage; current.image.hidden = false; }
        } catch {
          if (token === revision) current.availability.textContent = labels.check_failed;
        }
      }
    };
    Promise.all(Array.from({ length: Math.min(3, rows.length) }, refresh));
  };
  const change = next => { if (!save(next)) return false; sync(); if (dialog.open) render(); return true; };
  const open = trigger => {
    if (dialog.open) return;
    opener = trigger; previousOverflow = document.body.style.overflow;
    entries = read(); dialog.showModal(); document.body.style.overflow = 'hidden'; sync(); render();
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-rm-wishlist-toggle], [data-rm-wishlist-open], [data-rm-wishlist-remove], [data-rm-wishlist-close]');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (button.hasAttribute('data-rm-wishlist-open')) { open(button); return; }
    if (button.hasAttribute('data-rm-wishlist-close')) { dialog.close(); return; }
    entries = read();
    const id = button.dataset.rmWishlistRemove || button.dataset.id;
    const existing = entries.find(item => item.id === id);
    if (existing) {
      const nextButton = button.parentElement?.nextElementSibling?.querySelector('[data-rm-wishlist-remove]') || button.parentElement?.previousElementSibling?.querySelector('[data-rm-wishlist-remove]');
      const focusId = nextButton?.dataset.rmWishlistRemove;
      if (change(entries.filter(item => item.id !== id))) {
        announce(labels.removed);
        if (dialog.open && button.hasAttribute('data-rm-wishlist-remove')) (list.querySelector('[data-rm-wishlist-remove="' + focusId + '"]') || dialog.querySelector('[data-rm-wishlist-close]')).focus();
      }
      return;
    }
    if (entries.length >= 200) { announce(labels.limit); return; }
    const item = normalise([{ id, handle: button.dataset.handle, title: button.dataset.title, image: button.dataset.image, price: button.dataset.price, currency: config.currency }])[0];
    if (item && change([item, ...entries])) announce(labels.added);
  }, true);
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    revision++; document.body.style.overflow = previousOverflow || ''; sync();
    if (opener?.isConnected) opener.focus();
  });
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    entries = read(); sync(); if (dialog.open) render();
  });
  let scheduled = false;
  new MutationObserver(records => {
    if (scheduled) return;
    const needsSync = records.some(record => {
      if (record.type === 'attributes') {
        return record.attributeName === 'hidden'
          && record.target instanceof HTMLElement
          && record.target.matches('[data-rm-wishlist-open], [data-rm-wishlist-count]')
          && record.target.hidden;
      }
      return [...record.addedNodes].some(node =>
        node instanceof Element && (
          node.matches('[data-rm-wishlist-toggle], [data-rm-wishlist-open], [data-rm-wishlist-count]') ||
          node.querySelector('[data-rm-wishlist-toggle], [data-rm-wishlist-open], [data-rm-wishlist-count]')
        )
      );
    });
    if (!needsSync) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; sync(); });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  window.riamatoWishlistReady = true;
  entries = read(); sync();
})();
